<div class="modal-content p-4">
  <div class="col-12 custom-box p-5">
    <header id="header" class="row align-items-center justify-content-between sticky-header">
      <div class="left-section">
        <span class="back-button" (click)="closeModal()">
          <i class="fas fa-angle-left"></i> Voltar
        </span>
      </div>
      <h3 class="form-title text-center">Editar Credores Pessoa Jurídica</h3>
      <div class="right-section">
        <button class="btn" (click)="updateEmpresa()">Atualizar</button>
      </div>
    </header>
    <form [formGroup]="formEmpresa">
      <div formArrayName="empresas">
        <div id="formEmpresas" class="mt-5" *ngFor="let emp of empresas.controls; let e = index" [formGroupName]="e">
          <div class="form-row align-items-center">
            <div class="col">
              <h2>Credor Pessoa Jurídica {{ e + 1 }}</h2>
            </div>
            <div *ngIf="emp.get('delete').value" class="col-auto">
              <button class="btn-trash text-end" type="button" (click)="removeEmpresa(e)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="form-row mt-5">
            <div class="col-md-5">
              <label class="form-label">
                CNPJ <b class="text-danger">*</b>
              </label>
              <input type="text" formControlName="cnpj" autocomplete="off"  mask="AA.AAA.AAA/AAAA-AA" class="form-control">
              <span class="error-form ml-2" *ngIf="emp.get('cnpj')?.invalid && (emp.get('cnpj')?.dirty || emp.get('cnpj')?.touched)">Campo obrigatório.</span>

            </div>
            <div class="col-md">
              <label class="form-label">
                Razão Social <b class="text-danger">*</b>
              </label>
              <input type="text" maxlength="150" formControlName="nomeEmpresa" autocomplete="off" class="form-control">
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('required') && (emp.get('nomeEmpresa')?.dirty || emp.get('nomeEmpresa')?.touched)">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="emp.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
            </div>
          </div>

          <div formArrayName="representantes">
            <div class="mt-5" *ngFor="let rep of getRepresentantes(e).controls; let i = index" [formGroupName]="i">
              <div class="form-row align-items-center">
                <div class="col">
                  <h2>Representante Legal {{ i + 1 }}</h2>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="col-md-5">
                  <label class="form-label">
                    Nome <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input type="text" autocomplete="off-" formControlName="nome" maxlength="150" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('nome')?.hasError('required') && (rep.get('nome')?.dirty || rep.get('nome')?.touched)">Campo obrigatório.</span>
                </div>
                <div class="col-md">
                  <label class="form-label">
                    CPF <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input type="text" autocomplete="off" formControlName="cpf"  mask="000.000.000-00" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('cpf')?.hasError('required') && (rep.get('cpf')?.dirty || rep.get('cpf')?.touched)">Campo obrigatório.</span>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="col-md">
                  <label class="form-label">
                    E-mail <b class="text-danger" *ngIf="i === 0">*</b>
                  </label>
                  <input type="text" formControlName="emailPj" autocomplete="off-" class="form-control">
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('required') && (rep.get('emailPj')?.dirty || rep.get('emailPj')?.touched)">Campo obrigatório.</span>
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                </div>
              </div>
            </div>

          </div>
          <hr>
        </div>
      </div>
      <p class="info-text mb-4">
        <i class="fas fa-info-circle"></i>
        O Representante Legal indicado deve possuir poderes de representação para assinar o termo em nome do Credor Pessoa Jurídica, de acordo com a documentação Societária e Procuração (se houver) a ser enviada.
      </p>
      <div class="p-3 form-row justify-content-center">
        <button class="btn " type="button" (click)="addEmpresa()">
          Adicionar Pessoa Jurídica
        </button>
      </div>
    </form>
  </div>
</div>
